<template>
  <div>
    <b-modal
      v-if="isModalOpen"
      v-model="isModalOpen"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-label="Modal"
      aria-modal
      v-bind="$attrs"
      @close="isModalOpen = false"
    >
      <div class="exportweblinkandstatus__alert">
        <h1 class="header_title mb-3" style="text-align: left; width: 100%">
          Exporting Weblink
        </h1>

        <div>
          <p class="services_results_length mb-3 mt-0">
            You are about to export the weblink. Do you want to change the
            request status to {{ statusToChange }}?
          </p>

          <PhasesProgress
            :reduced-view="true"
            :steps="
              helpers.getQuoteStatusPhases(quoteStatus, orderedQuoteStatuses)
            "
          />
        </div>

        <footer class="w-100 mt-2 footer__button px-4 pr-6">
          <BaseButton
            action="secondary"
            data-action-type="EXPORT:ITINERARY_WEBLINK_EXPORT"
            @click="onCancel"
          >
            <p slot="text">Only Export</p>
          </BaseButton>
          <BaseButton
            action="principal"
            :id-element="'confirmButton'"
            data-action-type="EXPORT:ITINERARY_STATUS_CHANGE_AND_WEBLINK_EXPORT"
            @click="onContinue"
          >
            <p slot="text">Change to Sent and Export Weblink</p>
          </BaseButton>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PhasesProgress from "@/components/_shared/PhasesProgress.vue";
import { USER_ROLE } from "@/constants";
import helpers from "@/helpers";
import { helper } from "@/utils/itinerary";

export default {
  name: "ExportWeblinkAndStatusAlert",
  components: {
    PhasesProgress,
  },
  props: {
    setLoading: {
      type: Function,
      default: () => {},
    },
    statusToChange: {
      type: String,
      default: "",
    },
    onCancel: {
      type: Function,
      default: () => {},
    },
    onContinue: {
      type: Function,
      default: () => {},
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filteredResults: [],
      isModalOpen: this.isOpen,
      isLinkToRequestAlertOpen: false,
      searchPayload: {
        client: "",
        contract: "",
        stage: [],
        creation_date: "",
        text: "",
      },
      requestSelected: {},
      helpers: {
        ...helper,
      },
    };
  },
  computed: {
    ...mapGetters({
      users: "users/getUsers",
      authData: "auth/getAuthData",
      itinerary: "itinerary/getItinerary",
      requests: "request/getRequests",
      quoteStatus: "itinerary/getItineraryStatus",
      status_itinerary: "status_itinerary/getQuoteStatuses",
    }),
    orderedQuoteStatuses() {
      return JSON.parse(JSON.stringify(this.status_itinerary)).sort((a, b) => {
        return a.order - b.order;
      });
    },
    resultsLength() {
      return this.users?.data?.length || 0;
    },
    isTravelAgent() {
      return helpers.hasAnyRoles(
        this.authData.user,
        [USER_ROLE.TRAVEL_AGENT],
        false
      );
    },
  },
  watch: {
    isModalOpen(newValue) {
      if (this.isOpen === newValue) return;
      this.$emit("update:isOpen", newValue);
    },
    isOpen(newValue) {
      this.isModalOpen = newValue;
      this.$store.dispatch("utils/setIsModalOpen", newValue);
      if (newValue) this.onMounted();
      else this.resetComponentState();
    },
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("request/SET_QUOTE_TO_LINK_TO_REQUEST", null);
    next();
  },
  methods: {
    updateSearchPayload(payload) {
      this.searchPayload = payload;
      this.filterServices();
    },
    closeLinkToRequestModal() {
      this.isModalOpen = false;
    },
    async onMounted() {},
    resetComponentState() {
      this.filteredResults = [];
    },
    async onConfirm() {
      this.setLoading(true);

      const response = await this.$store.dispatch(
        "request/linkQuoteToRequest",
        {
          requestId: this.requestSelected.id,
          currentRequest: this.requestSelected,
          quotesToLink: this.quotesToLink.map((quote) => ({
            ...quote,
            title: quote.title.value,
          })),
        }
      );

      this.$buefy.toast.open({
        duration: 5000,
        message:
          response.type == "success"
            ? "Quote linked to request successfully"
            : "Error linking quote to request",
        position: "is-top",
        type: response.type == "success" ? "is-success" : "is-danger",
        pauseOnHover: true,
      });

      this.onContinue();
      this.isLinkToRequestAlertOpen = false;
      this.setLoading(false);
    },
  },
};
</script>

<style>
.exportweblinkandstatus__alert .selectContainer {
  display: block;
}
.exportweblinkandstatus__alert .btnClose {
  background-color: transparent;
  border: none;
  padding: 0;
}
.animation-content {
  z-index: 999;
}
.exportweblinkandstatus__alert {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 36rem;
  height: 19rem;
  border-radius: 1rem;
  padding: 2rem 2rem 3rem;
  text-align: center;
  position: relative;
}
.exportweblinkandstatus__alert .services_results_length {
  display: block;
  width: 100%;
  text-align: left;
  font-size: 0.8rem;
  font-weight: 400;
  color: #000;
}
.header_title {
  font-size: 1.2rem;
  font-weight: 700;
  text-align: left;
  padding-top: 0.25rem;
  padding-bottom: 0.8rem;
}
.exportweblinkandstatus__alert .select,
.exportweblinkandstatus__alert select {
  width: 100%;
}

.exportweblinkandstatus__alert .header {
  position: relative;
  width: 100%;
  text-align: left;
  padding-bottom: 0.2rem;
}
.exportweblinkandstatus__alert .header .header_select {
  margin: 0.3rem 0;
  display: inline-block;
}
.exportweblinkandstatus__alert .header .header_select :is(label) {
  text-align: left;
  margin-left: 0.25rem;
  font-size: 0.8rem !important;
}
.exportweblinkandstatus__alert
  .header
  .header_select
  :is(.select, select, .b-form-datepicker.base-datePicker.form-control) {
  font-size: 0.8rem !important;
  width: 100% !important;
  border-radius: 0.5rem !important;
}
.exportweblinkandstatus__alert
  .header
  .header_select
  :is(select:focus, .b-form-datepicker.base-datePicker.form-control:focus, .b-form-datepicker.base-datePicker.form-control:hover) {
  border-color: #f00b81 !important;
  box-shadow: 0 0 0 0.125em #f00b8138 !important;
}
.exportweblinkandstatus__alert .header .header_select .select::after {
  border-color: #f00b81;
}
.exportweblinkandstatus__alert .header .input_search {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 0.5rem;
  border-bottom: 1px solid #f00b81;
}
.exportweblinkandstatus__alert .header .input_search .input {
  outline: none;
  border: none;
  border-radius: 0px;
  box-shadow: none;
  padding: 0.25rem 0.5rem;
  font-size: 0.8rem;
  width: 18rem;
}
.exportweblinkandstatus__alert .header svg {
  color: #f00b81 !important;
  width: 1.2rem !important;
  height: 1.2rem !important;
}
.button_search {
  background: #f00b81;
  border: none;
  border-radius: 0.5rem;
  padding: 0.25rem 0.5rem;
}
.exportweblinkandstatus__alert .button_search :is(svg) {
  color: #fff !important;
}

.exportweblinkandstatus__alert .footer__button {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
}

.item {
  background-color: #fff;
  border: none;
  display: flex;
  flex-direction: column;
  text-align: left;
  width: 100%;
  padding: 0.5rem;
  border-bottom: 1px solid rgba(217, 217, 217, 0.25);
  cursor: pointer;
  border-radius: 0.5rem;
}
.item.disabled {
  cursor: not-allowed;
  background-color: #eeeeee;
}
.item:hover {
  background-color: rgba(217, 217, 217, 0.25);
  border-radius: 0.5rem;
  color: #fff;
}
.item__top {
  font-size: 0.8rem;
  font-weight: 400;
  color: #6d6d6d;
}
.item__bottom {
  font-size: 0.8rem;
  font-weight: 600;
  color: #444444;
}

.exportweblinkandstatus__alert .results__container {
  max-height: 100%;
  overflow-y: auto;
  margin-bottom: 2rem;
}

.form_stage__control label {
  text-align: left;
  margin-left: 0.25rem;
  font-size: 0.8rem !important;
}

.form_stage__control .multiselect__tag {
  margin-bottom: 0rem;
}

.footer__button .field:not(:last-child) {
  margin-bottom: 0rem;
}

@media screen and (max-width: 480px) {
  .exportweblinkandstatus__alert {
    padding: 1rem;
    height: 100%;
  }
}
</style>
